export default {
  // 접속한 계정에 노출되는 메뉴 리스트
  list: [],
  // 메뉴 검색
  search: '',

  pageTitle: "",
  pagePath: [],

  // 메인화면에서 노출되는 팝업 리스트
  modalItems: [],

  // Write페이지 사업장 선택시 저장되고, 같은 boardid의 list에서 URLSearchParams
  // {boardId:0, name:"name"}
  listSearchFiledName: null,

  // 작성페이지 입력 여부
  // writeOldForm 와 writeForm 를 비교하여, 메뉴 클릭시 _blank 로 열릴지 여부를 판단한다.
  writeForm: undefined,
  writeOldForm: undefined,
};
